import { Splitter, type SplitterProps } from '@progress/kendo-react-layout'
import classNames from 'classnames'
import React from 'react'

import styles from './StyledSplitter.css'

export type StyledSplitterProps = React.PropsWithChildren<{
  className?: string
  'data-testid'?: string
  onChange?: (panes: SplitterProps['panes']) => void
  panes: SplitterProps['panes']
  splitBarSpacing?: 0 | 1 | 2 | 4 | 8
}>

export const StyledSplitter = ({
  children,
  className,
  'data-testid': dataTestId = 'components-elements-styled-splitter',
  onChange,
  panes,
  splitBarSpacing = 0,
}: StyledSplitterProps) => {
  const handleSplitterChange = React.useCallback<EH<SplitterProps, 'onChange'>>(
    (event) => {
      onChange?.(event.newState)
    },
    [onChange],
  )

  return (
    <Splitter
      className={classNames(
        styles.root,
        styles[`splitBarSpacing-${splitBarSpacing}`],
        className,
      )}
      data-testid={dataTestId}
      panes={panes}
      onChange={handleSplitterChange}
    >
      {children}
    </Splitter>
  )
}
